var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DD6B55;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Exclamation",
    transform: "translate(228.000000, 278.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-196-222.1c-13.2,0-23.9-10.7-23.9-23.9c0-13.2,10.7-23.9,23.9-23.9s23.9,10.7,23.9,23.9     C-172.1-232.8-182.8-222.1-196-222.1L-196-222.1z M-196-267.3c-11.7,0-21.3,9.6-21.3,21.3s9.6,21.3,21.3,21.3s21.3-9.6,21.3-21.3     S-184.3-267.3-196-267.3L-196-267.3z",
    id: "Fill-49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-50",
    points: "-197.4,-236.1 -194.6,-236.1 -194.6,-233.3 -197.4,-233.3    "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    id: "Fill-51",
    points: "-195.2,-238.9 -196.8,-238.9 -197.4,-250.2 -197.4,-258.7 -194.6,-258.7      -194.6,-250.2 -195.2,-238.9    "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationWarning);
export default __webpack_public_path__ + "static/media/exclamation_warning.65b2e2d7498e0d99bd42b8b19aed4b28.svg";
export { ForwardRef as ReactComponent };